import * as React from 'react';

import { getEventQueue } from '../../../utils/eventQueue';

import type { TAdBannerEventPrefix } from '../../../types/events';

interface IUseAdBannerMicrofrontendEventsParams {
  placeId: string;
  isReady: boolean;
  onStub?(): void;
  onError?(): void;
  onClose?(): void;
}

/**
 * Подписывает хост на lifecycle-события микрофронтенда. Ключ топиков — тот же placeId,
 * который уезжает в parameters микрофронтенда.
 */
export function useAdBannerMicrofrontendEvents({
  placeId,
  isReady,
  onStub,
  onError,
  onClose,
}: IUseAdBannerMicrofrontendEventsParams): void {
  React.useEffect(() => {
    if (!isReady || (!onStub && !onError && !onClose)) {
      return undefined;
    }

    const eventQueue = getEventQueue();
    const prefix: TAdBannerEventPrefix = `ad-banner-frontend-reporting.v1.${placeId}.ad-banner-`;
    const stubEventName = `${prefix}stub` as const;
    const errorEventName = `${prefix}error` as const;
    const closeEventName = `${prefix}close` as const;

    if (onStub) {
      eventQueue.on(stubEventName, onStub);
    }

    if (onError) {
      eventQueue.on(errorEventName, onError);
    }

    if (onClose) {
      eventQueue.on(closeEventName, onClose);
    }

    return () => {
      if (onStub) {
        eventQueue.off(stubEventName, onStub);
      }

      if (onError) {
        eventQueue.off(errorEventName, onError);
      }

      if (onClose) {
        eventQueue.off(closeEventName, onClose);
      }
    };
  }, [placeId, isReady, onStub, onError, onClose]);
}
